import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FaBook, FaFileAlt, FaLightbulb, FaScroll, FaGlobeAmericas,FaBookOpen, FaUniversity, FaChartLine, FaBalanceScale } from "react-icons/fa"; // Import icons from react-icons
import "./Mains.scss"; // Import the CSS file for styling

const Mains = () => {
  // State to track mobile view
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // State to track grid layout based on screen size
  const [gridTemplateColumns, setGridTemplateColumns] = useState('1fr 1fr'); // Default to 2 columns for desktop

  const updateGridColumns = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile); // Check if screen is mobile size
    setGridTemplateColumns(mobile ? '1fr' : '1fr 1fr'); // Set to 1 column for mobile, 2 columns for desktop
  };

  useEffect(() => {
    updateGridColumns(); // Set initial grid columns

    // Attach event listener to handle window resize
    window.addEventListener('resize', updateGridColumns);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateGridColumns);
    };
  }, []);

  // Define the styles for the grid
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: gridTemplateColumns,
    gap: '20px', // Add spacing between cards
  };

  // Define the titles, paths, icons, and corresponding descriptions for the cards
  const cardData = [
    {
      title: "Syllabus",
      path: "/freeresources/FRMainsSyllabus",
      icon: FaBook,
      description: "Access the comprehensive syllabus to guide your Mains preparation."
    },
    // {
    //   title: "Essay",
    //   path: "/freeresources/FRMainsEssay",
    //   icon: FaFileAlt,
    //   description: "Explore essay topics and tips to enhance your writing skills for Mains."
    // },
    // {
    //   title: "PYQ Mains",
    //   path: "/freeresources/FRMainsPYQMains",
    //   icon: FaLightbulb,
    //   description: "Review previous year Mains questions to understand the exam pattern."
    // },
    // {
    //   title: "Hot Topics for Mains",
    //   path: "/freeresources/FRMainsHotTopicsforMains",
    //   icon: FaScroll,
    //   description: "Stay informed on the most important and trending topics for Mains."
    // },
    {
      title: "GS I",
      path: "/freeresources/FRMainsGS1Overview",
      icon: FaGlobeAmericas,
      description: "Prepare for GS Paper I with resources covering History, Geography, and more."
    },
    {
      title: "GS I Notes",
      path: "/freeresources/FRMainsGS1Notes",
      icon: FaBookOpen, // Represents study materials and notes
      description: "Comprehensive notes for GS Paper I, covering History, Geography, and essential topics."
    },
    {
      title: "GS II",
      path: "/freeresources/FRMainsGS2Overview",
      icon: FaUniversity,
      description: "Focus on Governance, Constitution, and International Relations for GS Paper II."
    },
    {
      title: "GS II Notes",
      path: "/freeresources/FRMainsGS2Notes",
      icon: FaBookOpen, // Represents study materials and notes
      description: "Comprehensive notes for GS Paper II, covering History, Geography, and essential topics."
    },
    {
      title: "GS III",
      path: "/freeresources/FRMainsGS3Overview",
      icon: FaChartLine,
      description: "Get resources on Economy, Environment, and Science & Tech for GS Paper III."
    },
    {
      title: "GS III Notes",
      path: "/freeresources/FRMainsGS3Notes",
      icon: FaBookOpen, // Represents study materials and notes
      description: "Comprehensive notes for GS Paper III, covering History, Geography, and essential topics."
    },
    {
      title: "GS IV",
      path: "/freeresources/FRMainsGS4Overview",
      icon: FaBalanceScale,
      description: "Enhance your understanding of Ethics, Integrity, and Aptitude for GS Paper IV."
    },
    {
      title: "GS IV Notes",
      path: "/freeresources/FRMainsGS4Notes",
      icon: FaBookOpen, // Represents study materials and notes
      description: "Comprehensive notes for GS Paper IV, covering History, Geography, and essential topics."
    },
    {
      title: "PSIR Paper I",
      path: "/freeresources/FRMainsPSIRPaper1",
      icon: FaFileAlt, // Replace with FaGlobeAmericas for a world-related icon
      description: "Dive into Political Science and International Relations with focused resources to excel in your optional subject."
    },
    {
      title: "PSIR Paper II",
      path: "/freeresources/FRMainsPSIRPaper2",
      icon: FaFileAlt, // Replace with FaGlobeAmericas for a world-related icon
      description: "Dive into Political Science and International Relations with focused resources to excel in your optional subject."
    }

  ];

  return (
    <div className="section1-container">
      <div className="card-container" style={gridStyle}>
        {cardData.map((card, index) => (
          <Link to={card.path} key={index} className="card">
            <h4 style={{ fontSize: "18px" }}>
              <card.icon style={{ marginRight: '10px', color: "#DD5D59" }} /> {card.title} {/* Use the icon component */}
            </h4>
            <h6 className="cardh6" style={{ fontWeight: "600", fontSize: "17px" }}>{card.description}</h6> {/* Display the description */}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Mains;
